import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SigninService {
  public static dialogResult = false;
  headers: any;
  otpState$ = new BehaviorSubject<string>(null);

  constructor(private http: HttpClient) {}

  postSignIn(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/auth/user/sign_in', body, {});
  }

  // signInUser(body: any): Observable<any> {
  //   return this.http.post<any>(
  //     environment.proxyApiUrl + '/community/web/api/sign/in',
  //     body,
  //     {
  //       headers: this.headers,
  //     }
  //   );
  // }
  // signUpUser(body: any): Observable<any> {
  //   return this.http.post<any>(
  //     environment.proxyApiUrl + '/community/web/api/sign/up',
  //     body,
  //     {
  //       headers: this.headers,
  //     }
  //   );
  // }

  // loginWithFacebook(body: any): Observable<any> {
  //   return this.http.post<any>(environment.proxyApiUrl +
  //     '/community/web/api/social/media/sign/in', body, {
  //     headers: this.headers,
  //   });
  // }
  // loginWithTwitter(body: any): Observable<any> {
  //   return this.http.post<any>(environment.proxyApiUrl +
  //     '/community/web/api/social/media/sign/in', body, {
  //     headers: this.headers,
  //   });
  // }
}
